import React from 'react'
import { Route, Routes } from 'react-router-dom'
import AllTeam from '../team/AllTeam'

function TeamRoute() {
  return (
    <>
      <Routes>
        <Route path='/all-team' element={<AllTeam/>}/>
      </Routes>
    </>
  )
}

export default TeamRoute
